import { render, staticRenderFns } from "./Smena.vue?vue&type=template&id=206d0748&scoped=true&"
import script from "./Smena.vue?vue&type=script&lang=js&"
export * from "./Smena.vue?vue&type=script&lang=js&"
import style0 from "./Smena.vue?vue&type=style&index=0&id=206d0748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d0748",
  null
  
)

export default component.exports